/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerUpdateRequestBranding } from './CustomerUpdateRequestBranding';
import {
    CustomerUpdateRequestBrandingFromJSON,
    CustomerUpdateRequestBrandingFromJSONTyped,
    CustomerUpdateRequestBrandingToJSON,
} from './CustomerUpdateRequestBranding';

/**
 * A change to the customer config. A field left out is kept.
 * @export
 * @interface CustomerConfigUpdateRequest
 */
export interface CustomerConfigUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof CustomerConfigUpdateRequest
     */
    claimFormInactivityTimeoutMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigUpdateRequest
     */
    freshdeskId?: string | null;
    /**
     * The lottery's branding, stored in game data
     * @type {CustomerUpdateRequestBranding}
     * @memberof CustomerConfigUpdateRequest
     */
    branding?: CustomerUpdateRequestBranding;
}

/**
 * Check if a given object implements the CustomerConfigUpdateRequest interface.
 */
export function instanceOfCustomerConfigUpdateRequest(value: object): value is CustomerConfigUpdateRequest {
    return true;
}

export function CustomerConfigUpdateRequestFromJSON(json: any): CustomerConfigUpdateRequest {
    return CustomerConfigUpdateRequestFromJSONTyped(json, false);
}

export function CustomerConfigUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfigUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimFormInactivityTimeoutMs': json['claimFormInactivityTimeoutMs'] == null ? undefined : json['claimFormInactivityTimeoutMs'],
        'freshdeskId': json['freshdeskId'] == null ? undefined : json['freshdeskId'],
        'branding': json['branding'] == null ? undefined : CustomerUpdateRequestBrandingFromJSON(json['branding']),
    };
}

export function CustomerConfigUpdateRequestToJSON(value?: CustomerConfigUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimFormInactivityTimeoutMs': value['claimFormInactivityTimeoutMs'],
        'freshdeskId': value['freshdeskId'],
        'branding': CustomerUpdateRequestBrandingToJSON(value['branding']),
    };
}

